import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from '@tanstack/react-router';
import Loading from 'components/Loading';
import { useApplyEmailVerification } from 'features/auth';
const WELCOME_DISPLAY_MS = 1500;
export default function AuthActionScreen({ mode, oobCode }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const apply = useApplyEmailVerification();
    const [showWelcome, setShowWelcome] = useState(false);
    useEffect(() => {
        if (mode === 'resetPassword') {
            navigate({ to: '/reset-password', search: { code: oobCode } });
            return;
        }
        apply.mutate({ code: oobCode }, {
            onSuccess: () => {
                setShowWelcome(true);
                window.setTimeout(() => navigate({ to: '/' }), WELCOME_DISPLAY_MS);
            },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mode, oobCode]);
    const errorMessage = apply.error ? toMessage(apply.error, t) : null;
    if (showWelcome) {
        return (_jsx("div", { className: "flex min-h-screen items-center justify-center bg-[#f9fafb] px-4 py-8 text-[#0a0a0a]", children: _jsxs("div", { className: "flex max-w-160 flex-col items-center gap-3 border-2 border-[#bfdbfe] bg-[#eff6ff] p-8.5 text-center", children: [_jsx("h2", { className: "m-0 text-[24px] font-semibold leading-8 text-[#1d4ed8]", children: t('auth_welcome') }), _jsx("p", { className: "m-0 text-[16px] leading-6 text-[#1d4ed8]", children: "Redirecting to your workspace\u2026" })] }) }));
    }
    return (_jsxs("div", { style: { position: 'relative', minHeight: '100vh', background: '#ffffff' }, children: [_jsx(Loading, { isVisible: apply.isPending || !errorMessage, title: t('auth_checking') }), errorMessage && (_jsx("div", { className: "flex min-h-screen items-center justify-center bg-[#f9fafb] px-4 py-8 text-[#0a0a0a]", children: _jsxs("div", { className: "max-w-160 border-2 border-[#fecaca] bg-white p-8.5 text-center", children: [_jsx("h2", { className: "m-0 text-[24px] font-semibold leading-8", children: errorMessage }), _jsx("button", { className: "mt-4 inline-flex min-h-10.5 items-center justify-center border border-[#99a1af] bg-white px-4 text-[16px] leading-6 text-[#0a0a0a]", onClick: () => navigate({ to: '/login' }), type: "button", children: t('auth_sign_out') })] }) }))] }));
}
function toMessage(error, t) {
    const code = error?.code;
    if (code === 'auth/expired-action-code' || code === 'auth/invalid-action-code') {
        return t('auth_verification_expired');
    }
    return error?.message || t('auth_verification_expired');
}
